import React from "react";
import { Link } from "react-router-dom";
import "./RankItem.css";
import constants from "../../utilities/constants.json";
import UserFaceAlt from "../../assets/img/avatar-face.jpg";

const imageUrl = constants.profile_image;

export default function RankItem({ ranks, index, type }) {
  const currentRank = type === 1 ? ranks.daily_rank : ranks.all_time_rank;
  const isTopThree = type !== 1 && currentRank <= 3;

  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = UserFaceAlt;
  };

  const truncateName = (name) => {
    return name?.length > 15 ? `${name.substring(0, 15)}...` : name;
  };

  return (
    <div className={`leaderboard-player-wrapper ${isTopThree ? "top-ten" : ""}`}>
      <Link
        to={localStorage.webKey ? "/mobile-user-profile" : "#"}
        state={{ rank: ranks.all_time_rank, user_id: ranks.user._id.$oid }}
        className="player-data"
      >
        <div className="playerInfo">
          <div className="playerImg">
            <img
              src={`${imageUrl}${ranks.user?.image}`}
              alt={ranks.user?.name}
              onError={handleImageError}
            />
          </div>
          <p className="playerName">{truncateName(ranks.user?.name)}</p>
        </div>

        <p className="playerPoints">{ranks.score} Pts</p>

        <p className="playerRank">
          <span className="rankBadge">{currentRank}</span>
        </p>
      </Link>
    </div>
  );
}
